export default "__VITE_ASSET__ca4a64b0__"